import { RedesignPreference } from '../enums/RedesignPreference';

const STORAGE_KEY = 'vendorCentral_navigationRedesign_preference';

export function getRedesignPreference() {
    const preference = localStorage.getItem(STORAGE_KEY);
    return preference in RedesignPreference ? preference : RedesignPreference.none;
}

export function setRedesignPreference(preference) {
    localStorage.setItem('vendorCentral_navigationRedesign_preference', preference);
}
